var chunkMapping = {
	"4984": [
		54984
	]
};
var idToExternalAndNameMapping = {
	"54984": [
		"default",
		"./mountPlay",
		98608
	]
};
var idToRemoteMap = {
	"54984": [
		{
			"externalType": "script",
			"name": "zep"
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes.chunkMapping = chunkMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToExternalAndNameMapping = idToExternalAndNameMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToRemoteMap = idToRemoteMap;
__webpack_require__.remotesLoadingData.moduleIdToRemoteDataMapping = {
	"54984": {
		"shareScope": "default",
		"name": "./mountPlay",
		"externalModuleId": 98608,
		"remoteName": "zep"
	}
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}